import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Button } from '@mui/material';
import Iconify from '../../../components/iconify';
import { checkComponentPermission, isManager } from '../../../utils/share';

const Header = ({ onCreateClick }) => {
  // User creation is gated by the CREATE_USER permission (admins).
  // Managers should also be able to create users (limited to Stakeholder/Client roles).
  const canCreateUser = checkComponentPermission('CREATE_USER') || isManager();

  return (
    <Stack direction="row" alignItems="center" justifyContent="flex-end" mb={2.5}>
      {canCreateUser && (
        <Button type="button" variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={onCreateClick}>
          New User
        </Button>
      )}
    </Stack>
  );
};

Header.propTypes = {
  onCreateClick: PropTypes.func,
};

export default Header;
